import { render, staticRenderFns } from "./rulesDetail.vue?vue&type=template&id=45d519f5&"
import script from "./rulesDetail.vue?vue&type=script&lang=js&"
export * from "./rulesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports